import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { TYPE } from 'customer-data-objects/task/TaskPropertyNames';
import { LINKED_IN_CONNECT, LINKED_IN_MESSAGE } from 'customer-data-objects/engagement/TaskTypes';
import { getLinkedInSalesNavigatorAppId, INTEGRATION_STATUS_CONNECTED } from '../cache/instances/marketplaceAppStatusCache';
import { useMarketplaceAppStatus } from '../v2/hooks/useMarketplaceAppStatus';
import { useMemo } from 'react';
import { getExcludedEnumOptions } from '../utils/getExcludedEnumOptions';
export const useExcludedEnumOptionsForProperty = ({
  objectTypeId,
  propertyName,
  value
}) => {
  const excludedEnumOptions = useMemo(() => getExcludedEnumOptions(objectTypeId, propertyName).filter(v => {
    if (Array.isArray(value)) {
      return !value.includes(v);
    } else {
      return v !== value;
    }
  }), [objectTypeId, propertyName, value]);
  const isTaskTypeProperty = objectTypeId === TASK_TYPE_ID && propertyName === TYPE;
  const {
    data: linkedInIntegrationStatus,
    loading: linkedInIntegrationStatusLoading
  } = useMarketplaceAppStatus({
    appId: getLinkedInSalesNavigatorAppId(),
    skip: !isTaskTypeProperty
  });
  if (isTaskTypeProperty && !linkedInIntegrationStatusLoading && linkedInIntegrationStatus !== INTEGRATION_STATUS_CONNECTED) {
    // Exclude LinkedIn Connect and LinkedIn Message options if LinkedIn Sales Navigator is not connected
    return [...excludedEnumOptions, LINKED_IN_CONNECT, LINKED_IN_MESSAGE];
  }
  return excludedEnumOptions;
};